import styled from 'styled-components';

export const Wrapper = styled.div<{ color?: string }>`
  z-index: 99999;
  position: fixed;
  bottom: 16px;
  background: ${({ color }) => color ?? 'var(--colorUISand)'};
  left: 50%;
  width: auto;
  transform: translateX(-50%);
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.2), 0px 20px 32px rgba(0, 0, 0, 0.2),
    0px 0px 40px rgba(0, 0, 0, 0.16);
  border-radius: 4px;
  padding: 16px 24px;
  animation: fade-in 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  min-width: 312px;

  svg {
    margin-left: 16px;
    cursor: pointer;
  }
`;
